
import { UltralyticsProcessing }  from "./ultralytics.js" 
import { ModelpackProcessing }  from "./modelpack.js" 

export function getInputFromSource(sourceEl,width,height) {
        // 3. Create a temporary canvas to resize
        const tmp = document.createElement("canvas");
        tmp.width = width;
        tmp.height = height;

        const ctxTmp = tmp.getContext("2d", { willReadFrequently: true });
        ctxTmp.drawImage(sourceEl, 0, 0, width, height);

        // 4. Read resized image data
        const imageData = ctxTmp.getImageData(0, 0, width, height);
        const data = imageData.data; // RGBA
        return data;
    }


export function  postprocessing(outputs,params) { 
    let type=params.type;
    let scoreThreshold=params.score_threshold;
    let iouThreshold=params.iou_threshold;
    let nc=params.nc;

    if (type=='modelpack') {
     
        const mpk = new ModelpackProcessing(params);
        return mpk.postProcess(outputs);

    }

    if (type=='ultralytics') {
        const ul = new UltralyticsProcessing(params);
        return ul.postProcess(outputs);

    }
}
